import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CollectionsPage from "../pages/collections/page";
import CollectionDetailPage from "../pages/collections/[slug]/page";
import ArchivePage from "../pages/archive/page";
import AboutPage from "../pages/about/page";
import FaqPage from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/collections",
    element: <CollectionsPage />,
  },
  {
    path: "/collections/:slug",
    element: <CollectionDetailPage />,
  },
  {
    path: "/archive",
    element: <ArchivePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;